
import { defineComponent, PropType } from "vue";
import { Block } from "@/components/common";

export default defineComponent({
  name: "BlockList",
  components: { Block },
  props: {
    items: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
});
